module.exports = __webpack_public_path__ + "img/949c76d.jpg";